export const APP_LOGOUT = 'app/logout';
export const appLogout = (expired) => ({
  type: APP_LOGOUT,
  expired: expired
});

export const APP_LOGOUT_SUCCESS = 'app/logout_success';
export const appLogoutSuccess = () => ({
  type: APP_LOGOUT_SUCCESS
});

export const ON_LOAD = 'app/on_load';
export const onLoad = () => ({
  type: ON_LOAD
});

export const ON_LOAD_SUCCESS = 'app/on_load_success';
export const onLoadSuccess = data => ({
  type: ON_LOAD_SUCCESS,
  payload: data
});

export const GET_LOGIN_USER_PROFILE='app/get_login_user_profile';
export const getLoginUserProfile = () => ({
  type: GET_LOGIN_USER_PROFILE
})

export const GET_LOGIN_USER_PROFILE_SUCCESS = 'app/get_login_user_profile_success';
export const getLoginUserProfileSuccess = data => ({
  type: GET_LOGIN_USER_PROFILE_SUCCESS,
  payload: data
})
